import { useState } from 'react';

const HIDDEN_TOOLTIP_STATE = {
  event: null,
  mousePos: null,
  show: false,
};

export const TOOLTIP_DELAY_MS = 450;

/**
 * Manages the delayed hover tooltip shown for scheduler events. The tooltip
 * only appears after the pointer has stayed over the event for
 * `TOOLTIP_DELAY_MS`, and is hidden immediately on mouse leave.
 */
function useEventTooltip() {
  const [tooltip, setTooltip] = useState(HIDDEN_TOOLTIP_STATE);

  const handleShowEventTooltip = (event, mousePos) => {
    setTooltip({ event, mousePos, show: true });
  };

  const handleHideEventTooltip = () => {
    setTooltip(HIDDEN_TOOLTIP_STATE);
  };

  return { tooltip, handleShowEventTooltip, handleHideEventTooltip };
}

export default useEventTooltip;
